module.exports = __webpack_public_path__ + "static/media/logo1.05186502.png";